import type { FC } from 'react';

import type { Company } from '@xing-com/crate-common-graphql-types';
import { useAppliedTheme } from '@xing-com/hub';

import { TopCompanyCard } from '../../../../components/top-company-card/top-company-card';
import { useTopCompanies } from '../../../../hooks/use-top-companies/use-top-companies';
import * as Styled from './top-companies-section.styles';

const LIMIT = 10;

export const TopCompaniesSection: FC = () => {
  const appliedTheme = useAppliedTheme();

  const { data, loading } = useTopCompanies({
    limit: LIMIT,
    offset: 0,
  });

  const companies =
    (data?.topCompanies?.collection.map(
      (item) => item?.company
    ) as Company[]) ?? [];

  return (
    <Styled.SectionSliderContainer
      darkMode={appliedTheme === 'dark'}
      title="CP_TOP_COMPANIES_SECTION_TITLE"
      subtitle="CP_TOP_COMPANIES_SECTION_SUBTITLE"
    >
      {loading &&
        Array.from({ length: LIMIT }, (_, index) => (
          <TopCompanyCard.Skeleton key={index} />
        ))}
      {companies?.map(
        (company) =>
          company && <TopCompanyCard key={company?.id} company={company} />
      )}
    </Styled.SectionSliderContainer>
  );
};
